import { render, staticRenderFns } from "./fixedAsset.vue?vue&type=template&id=fd5adde8&scoped=true"
import script from "./fixedAsset.vue?vue&type=script&lang=js"
export * from "./fixedAsset.vue?vue&type=script&lang=js"
import style0 from "./fixedAsset.vue?vue&type=style&index=0&id=fd5adde8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5adde8",
  null
  
)

export default component.exports